/* eslint-disable no-console */
import axios from 'axios';

import {API_BASE_URL, API_ENDPOINT_JSON} from '../../../config';
import CRUDMethods from '../../../constants/CRUDConstants';
import useJSONStore from '../../../store/StaticJson/jsonStore';
import useUserStore from '../../../store/userStore/userStore';

const getPermissionsApi = async (stackholderType?: string): Promise<any> => {
  const token = useUserStore.getState().userToken;
  const {
    internalPermissions,
    externalPermissions,
    setInternalPermissions,
    setExternalPermissions
  } = useJSONStore.getState();
  const isInternal = stackholderType === 'Internal';

  const type = isInternal ? 'internal' : 'External';

  const checkInStore =
    (isInternal
      ? Object.keys(internalPermissions)
      : Object.keys(externalPermissions)
    ).length > 0;

  if (!checkInStore) {
    try {
      const res = await axios.request({
        method: CRUDMethods.GET,
        url: `${API_BASE_URL}${API_ENDPOINT_JSON.getPermissions}/${type}`,
        headers: {
          Authorization: `Bearer ${token}`
        }
      });
      const mainData = res.data.data;
      isInternal
        ? setInternalPermissions(mainData)
        : setExternalPermissions(mainData);

      return mainData;
    } catch (err) {}
  } else {
    return isInternal ? internalPermissions : externalPermissions;
  }
};
export default getPermissionsApi;
